import { AtSign, KeyRound, LogOut } from 'lucide-react';
import posthog from 'posthog-js';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { redirectToLogout, useAuthentication } from '../../auth';
import { EmailSettingsModal } from '../../auth/views/EmailSettingsModal';
import { ResetPasswordModal } from '../../auth/views/ResetPasswordModal';
import { setToken } from '../../stores/slices/auth';
import { Button } from '../Button';
import { NoCapture } from '../NoCapture';

// TODO: Create popover component and use here
export const ProfileMenu = () => {
  const user = useAuthentication();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showEmailSettingsModal, setShowEmailSettingsModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event: { target: EventTarget | null }) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        profileRef.current &&
        !profileRef.current.contains(event.target as Node)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const getInitials = () => {
    if (user.name) {
      const names = user.name.split(' ');
      return names[0].charAt(0).toUpperCase() + names[names.length - 1].charAt(0).toUpperCase();
    }
    return '';
  };

  const signOutUser = async () => {
    posthog.reset();
    dispatch(setToken(undefined));
    redirectToLogout();
  };

  return (
    <div className="flex justify-end">
      <ResetPasswordModal userId={user.id} open={showResetPasswordModal} onOpenChange={setShowResetPasswordModal} />
      <EmailSettingsModal user={user} open={showEmailSettingsModal} onOpenChange={setShowEmailSettingsModal} />
      <div
        ref={profileRef}
        onClick={() => setShowMenu(!showMenu)}
        className="bg-accent flex h-8 w-8 cursor-pointer items-center justify-center rounded-xl text-black select-none hover:brightness-125 md:h-10 md:w-10"
      >
        {getInitials()}
      </div>
      {showMenu && (
        <div
          ref={dropdownRef}
          className="bg-secondary absolute top-20 z-100 flex flex-col items-center justify-center rounded-sm p-4 shadow-[0_4px_4px_rgba(0,0,0,0.25)]"
        >
          <div className="cursor-default text-center text-lg font-semibold">
            <NoCapture>{user.name}</NoCapture>
          </div>
          <hr className="text-highlight my-4 w-full" />
          <Button
            className="block w-full whitespace-nowrap *:justify-start"
            variant="transparent"
            icon={KeyRound}
            iconLayout="start"
            iconSize="m"
            onClick={() => {
              setShowResetPasswordModal(true);
              setShowMenu(false);
            }}
          >
            Reset password
          </Button>
          <Button
            className="block w-full whitespace-nowrap *:justify-start"
            variant="transparent"
            icon={AtSign}
            iconLayout="start"
            iconSize="m"
            onClick={() => {
              setShowEmailSettingsModal(true);
              setShowMenu(false);
            }}
          >
            Email settings
          </Button>
          <Button
            className="block w-full whitespace-nowrap *:justify-start"
            variant="transparent"
            icon={LogOut}
            iconLayout="start"
            iconSize="m"
            onClick={signOutUser}
          >
            Sign out
          </Button>
        </div>
      )}
    </div>
  );
};
